<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2 v-show="!trash">Terminal Agreements</h2>
				<h2 v-show="trash">Terminal Agreements - Trash</h2>
			</b-col>
		</div>
		<div v-show="list">
			<div class="card">
				<div class="card-body">
					<b-row>
						<b-container services>
							<div class="row">
								<b-col lg="4" class="my-1">
									<div class="input-group mb-3">
										<div class="input-group-prepend">
											<b-form-input v-model="filter" placeholder="Search" />
											<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
										</div>
									</div>
								</b-col>
								<b-col lg="3" class="my-1">
									<b-dropdown class="pull-left" :text="dpdt">
										<b-dropdown-item @click="trashAgreement()">Active</b-dropdown-item>
										<b-dropdown-item @click="trashAgreement()">Trash</b-dropdown-item>
									</b-dropdown>
								</b-col>
								<b-col lg="5" class="my-1">
									<b-button  :disabled="loadingData" @click="showNewLocationModal" variant="primary" class="active mb-3 pull-right">Add Terminal Agreement</b-button>
								</b-col>
							</div>
							<b-row v-if="loadingData">
								<b-col cols="12" sm="12" md="12" lg="12">
									<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
									</p>
								</b-col>
							</b-row>
							<b-table class="animated fadeIn" v-else striped hover bordered show-empty
								stacked="md"
								:items="items"
								:fields="fields"
								:current-page="currentPage"
								:per-page="perPage"
								:filter="filter"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								@filtered="onFiltered"
								@row-clicked="rowClicked">
								<!-- Details-->
								<template slot="row-details" slot-scope="row">
									<b-card>
										<ul>
											<li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
										</ul>
									</b-card>
								</template>
							</b-table>
							<!-- User Interface controls -->
							<b-row>
								<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
									<div class="input-group mb-3">
										<div class="input-group-prepend"> </div>
										<b-select :options="pageOptions" v-model="perPage" />
									</div>
								</b-col>
								<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
									<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
								</b-col>
							</b-row>
						</b-container>
					</b-row>
				</div>
			</div>
		</div>
		<!-- Unload Location Modal-->
		<b-modal title="Add Unload Location" v-model="newUnloadLocation" ok-only ok-title="Cancel" ok-variant = "secundary">
			<b-row>
				<b-col cols="12">
					<b-form-group :label-cols="4" horizontal label="Unload Location" label-for="Grouptarget1">
						<b-form-select :disabled="locations.length == 0" id="Grouptarget1" v-model="u_location_id" :options="locations"/>
					</b-form-group>
				</b-col>
			</b-row>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="newUnloadLocation=false" class="float-left">Cancel</b-btn>
				<b-btn size="md" variant="primary" @click="addunloadlocation()" class="float-right">Add</b-btn>
			</div>
		</b-modal>
		<!-- End Unload Location Modal-->
		
		<!-- Load Location Modal-->
		<b-modal title="Add Load Location" v-model="newLoadLocation" ok-only ok-title="Cancel" ok-variant = "secundary">
			<b-row>
				<b-form-group v-if="loadlocationselect.length > 0" :label-cols="4" id="L5" label="Load Locations" label-for="loadLocationsID" horizontal>
					<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
					<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
						{{ llAllSelected ? 'Un-select All' : 'Select All' }}
					</b-form-checkbox>
				</b-form-group>
			</b-row>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="hideloadlocation()" class="float-left">Cancel</b-btn>
				<b-btn size="md" variant="primary" @click="addloadlocation()" class="float-right">Add</b-btn>
			</div>
		</b-modal>
		<!-- End Load Location Modal-->

		<!-- Add new Terminal Agreement Modal -->
		<b-modal title="New Terminal Agreement" id="newModal" ref="newModal" v-model="newModal" size="lg">
			<div>
				<b-card no-body>
					<b-tabs card v-model="modalTabIndex">
						<b-tab title="Basic Info" active>
							<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="4" vertical label="Initial Date" label-for="initial_date">
										<b-form-input id="initial_date" v-model="model.initial_date" type="date"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col sm="6">
									<b-form-group :label-cols="4" vertical label="End Date" label-for="end_date">
										<b-form-input id="end_date" v-model="model.end_date" type="date"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6" v-if="role =='super_admin'">					
									<b-form-group :label-cols="3" vertical label="Energy Company" label-for="energyCompanies">
										<b-form-select value-field="id" text-field="name" id="energyCompanies" v-model="model.energy_company_id" :options="energycompanies" @input="select_energy_company">
											<template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">
									<b-form-group v-if="fluidtypes.length > 0" :label-cols="3" id="L5" label="Fluid Types" label-for="fluidtypesID" vertical>
										<b-form-radio-group value-field="other" text-field="name" v-model="fluid_type" class="custom-checkboxes" :options="fluidtypes" name="Checkboxes2" plain @input="select_fluid_type"></b-form-radio-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-if="model.other_terms.length > 0" >
								<b-col sm="6">		
									<b-form-group :label-cols="3" vertical label="Stream Type" label-for="streamtype">
										<b-form-select value-field="id" text-field="name" id="streamtype" v-model="model.other_terms[0].stream_type_id" :options="fluid_type.stream_type">
											<template slot="first"><option :value="null" disabled>-- select stream type --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">	
									<b-form-group :label-cols="3" vertical label="Blending Dry Fee" label-for="blending_dry_fee">
											<b-form-input id="blending_dry_fee" v-model="model.other_terms[0].blending_dry_fee" type="text" @keydown.native="myOnlyNumber($event, 'rate')"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Terminal Company" label-for="terminalCompanies">
										<b-form-select value-field="id" text-field="name" id="terminalCompanies" v-model="model.terminal_company_id" :options="terminalcompanies">
											<template slot="first"><option :value="null" disabled>-- select terminal company --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="6">					
									<b-form-group :label-cols="3" vertical label="Terminal" label-for="terminal">
										<b-form-select value-field="id" text-field="name" id="terminal" v-model="model.terminal_id" :options="terminals" @input="select_terminal">
											<template slot="first"><option :value="null" disabled>-- select terminal --</option></template>
										</b-form-select>
									</b-form-group>
								</b-col>
							<b-row>
							</b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" vertical label="Terminal Rate" label-for="rate">
										<b-form-input id="rate" v-model="model.rate" type="text" @keydown.native="myOnlyNumber($event, 'rate')" placeholder="The regular terminal fee that will apply to all hauls"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>	
						</b-tab>
						<b-tab title="Treatment Fees">
							<p>
      						Treatment fees that will apply only to those hauls which H2S condition apply as shows below 
    						</p>
							<b-table striped show-empty empty-text="No Treatement fees added"
								:fields = "[{key: 'delete', label: ' '}, {key: 'treatment_fee_type_id', label: 'Type'}, {key: 'treatment_fee', label: 'Treatment fee'}, {key: 'condition_id', label: 'Condition'}, {key: 'percentage', label: 'Percentage'}]" 
								:items="model.treatfees" stacked="sm" outlined small>
								<template slot="delete" slot-scope="item">
									<b-btn v-b-tooltip.hover title="Delete" v-on:click="removetreatmentfee(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
								</template>
								<template slot="treatment_fee_type_id" slot-scope="item">
									<b-form-select size="sm" id="type" v-model="model.treatfees[item.index].treatment_fee_type_id" :options="treatment_fee_type">
										<template slot="first"><option :value="null" disabled>-- select type --</option></template>
									</b-form-select>
								</template>
								<template slot="treatment_fee" slot-scope="item">
									<b-form-input size="sm" id="treatmentfee" v-model="model.treatfees[item.index].treatment_fee" type="text" @keydown.native="myOnlyNumber($event, 'treatmentfee')"/>
								</template>
								<template slot="condition_id" slot-scope="item">
									<b-form-select size="sm" id="condition" v-model="model.treatfees[item.index].condition_id" :options="condition">
										<template slot="first"><option :value="null" disabled>-- select condition --</option></template>
									</b-form-select>
								</template>
								<template slot="percentage" slot-scope="item">
									<b-form-input size="sm" id="percentage" v-model="model.treatfees[item.index].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
								</template>
							</b-table>
							<b-row>
								<b-col sm="12">
									<b-btn  v-on:click="addtreatmentfee()" size="sm" variant="primary" class="pull-right">Add New Treatment Fee</b-btn>
								</b-col>
							</b-row>
						</b-tab>
						<b-tab title="Other Fees">
							<p>
      							Any other fees added here will be automatically apply to all hauls that unload in this location that contains water as a fluid type
    						</p>
							<b-table striped show-empty empty-text="No other fees have been added"
								:fields = "[{key: 'delete', label: ' '}, {key: 'terminal_rate', label: 'Terminal Rate'}, {key: 'rate', label: 'Rate'}]" 
								:items="model.otherfees" stacked="sm" outlined small>
								<template slot="delete" slot-scope="item">
									<b-btn v-b-tooltip.hover title="Delete" v-on:click="removeotherfee(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
								</template>
								<template slot="terminal_rate" slot-scope="item">
									<b-form-input size="sm" id="otherfee" v-model="model.otherfees[item.index].terminal_rate" type="text" />
								</template>
								<template slot="rate" slot-scope="item">
									<b-form-input size="sm" id="otherrate" v-model="model.otherfees[item.index].rate" type="text" @keydown.native="myOnlyNumber($event, 'rate')"/>
								</template>
							</b-table>
							<b-row>
								<b-col sm="12">
									<b-btn  v-on:click="otherfee()" size="sm" variant="primary" class="pull-right">Add Other Fee</b-btn>
								</b-col>
							</b-row>
						</b-tab>
						<b-tab title="Unload Locations">
							<p>
							Any other fees added here will be automatically apply to all hauls that unload in this location that  contains water as a fluid type
							</p>
							<b-table striped show-empty empty-text="No Unload Locations have been added"
								:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: 'Unload Location'}, {key: 'shipping_cost', label: 'Shipping Cost'}, {key: 'monthly_commitment', label: 'Monthly Commitment'}, {key: 'contact_person', label: 'Contact Person'}, {key: 'contact_email', label: 'Contact Email'}, {key: 'show_details', label: ' '}]" 
								:items="model.unload_locations" stacked="sm" outlined small>
								<template slot="show_details" slot-scope="row">
									<b-btn v-b-tooltip.hover title="Add Terminal Cost" @click="addterminalcost(row)" size="sm" class="pull-right"><i class="icon-plus"></i> Cost</b-btn>
								</template>
								<template slot="row-details" slot-scope="row">
										<b-row class="mb-2">
											<b-col cols="7"><b>Terminal Cost</b></b-col>
											<b-col cols="5"><b>Percentage</b></b-col>
											<!--b-col></b-col-->
										</b-row>
										<b-row class="mb-2" v-for="(terminal_cost, index1) in model.unload_locations[row.index].terminal_costs" :key="index1">
											<b-col cols="7">
												<b-form-input size="sm" id="terminal_cost_name" v-model="model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name" type="text" />
											</b-col>
											<b-col cols="3">
												<b-form-input size="sm" id="terminal_cost_percentage" v-model="model.unload_locations[row.index].terminal_costs[index1].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
											</b-col>
											<b-col cols="2"><b-btn v-b-tooltip.hover title="Delete Terminal Cost" v-on:click="removeterminalcost(row, index1)" size="sm"><i class="icon-close"></i></b-btn></b-col>
										</b-row>
								</template>
								<template slot="name" slot-scope="item">
									<b-form-input size="sm" id="location" v-model="model.unload_locations[0].name" readonly>
									
									</b-form-input>
								</template>
								<template slot="shipping_cost" slot-scope="item">
									<b-form-input size="sm" id="shipping_cost" v-model="model.unload_locations[item.index].shipping_cost" type="text" />
								</template>
								<template slot="monthly_commitment" slot-scope="item">
									<b-form-input size="sm" id="monthly_commitment" v-model="model.unload_locations[item.index].monthly_commitment" type="text" @keydown.native="myOnlyNumber($event, 'monthly_commitment')"/>
								</template>
								<template slot="contact_person" slot-scope="item">
									<b-form-input size="sm" id="contact_person" v-model="model.unload_locations[item.index].contact_person" type="text" />
								</template>
								<template slot="contact_email" slot-scope="item">
									<b-form-input size="sm" id="contact_email" v-model="model.unload_locations[item.index].contact_email" type="text" />
								</template>
							</b-table>
						</b-tab>
						<b-tab title="Load Locations">
							<b-form-group v-if="loadlocationselect.length > 0" :label-cols="1" id="L5" label="" label-for="loadLocationsID" vertical>
								<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
									{{ llAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'}}</p>
						</b-tab>
					</b-tabs>
				</b-card>
			</div>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="newModal=false" class="float-left">Cancel</b-btn>
				<b-btn :disabled="savebtn" size="md" variant="primary" @click="saveTerminalAgreement" class="float-right">Save</b-btn>
			</div>
		</b-modal>
		<!-- End Add new Terminal Agreement -->
	</div>
</template>

<script>

	import Vue from 'vue'
	import t_agreement from './t_agreement'
	import moment from 'moment';
	import ec_service from '../energy_companies/ec_service'
	const items = []
	export default {
		name: 'terminal_agreements',
		created: function () {
			this.getAll()
			localStorage.removeItem("haulsaPage");
			localStorage.removeItem("targetsaPage");
			localStorage.removeItem("ftPage");
			localStorage.removeItem("targetPage");
			localStorage.removeItem("tpPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("oaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("rolesPage");
			localStorage.removeItem("servicePage");
			localStorage.removeItem("tasaPage");
			localStorage.removeItem("tcPage");
			localStorage.removeItem("locationPage");
	  		localStorage.removeItem("truckPage");
	  		localStorage.removeItem("userPage");
			if (!localStorage.taPage) {
				localStorage.taPage = 0;
			}
		},
		data () {
			return {
				newLocations: false,
				items: items,
				loadingData: true,
				dpdt: 'Active',
				trash: false,
				currentPage: parseInt(localStorage.taPage),
				perPage: 25,
				totalRows: items.length,
				pageOptions: [ 25, 50, 100],
				sortBy: 'id',
				sortDesc: true,
				filter: null,
				modalInfo: { title: '', content: '' },
				configTable: false,
				//
				fields: [
				  	{ key: 'id', label: 'Id', sortable: true },
				  	{ key: 'energy_company', label: 'Energy Company', sortable: true },
				  	{ key: 'initial_date', label: 'Initial Date', sortable: true, formatter: (value) => { return moment(value).format("MMM DD, YYYY") } },
			  		{ key: 'end_date', label: 'End Date', sortable: true, formatter: (value) => { return moment(value).format("MMM DD, YYYY") }},
					{ key: 'rate', label: 'Rate', sortable: true },
					{ key: 'fluid_type', label: 'Fluid Type', sortable: true },
					{ key: 'completed', label: 'Completed', sortable: true }
				],
				locations: [],
				energycompanies: [],
				rate: '',
				insert_data: null,
				role: '',
				view: true,
				savebtn: true,
				energy_company_id: null,
				// add by Carlos rondon 21/03/2019
				list: true,
				fluidtypes:	[],
				terminalcompanies: [],
				treatment_fee_type: [],
				condition: [],
				treatfees: {
					treatment_fee_type_id: null,
					treatment_fee: null,
					condition_id: null,
					percentage: null,
				},
				otherfees: {
					terminal_rate: null,
					rate: null
				},
				unload_location: {
					id: null,
					name: null,
					shipping_cost: null,
					monthly_commitment: null,
					contact_person: null,
					contact_email: null,
					terminal_costs: [],
				},
				terminal_cost: {terminal_cost_name: null, percentage : null},
				fluid_type: {id: null, name: null},
				other_term: { blending_dry_fee: null, stream_type_id: null},
				model:{
					id					: null,
					energy_company_id	: null,
					terminal_company_id : null,
					terminal_id 		: null,
					terminalcost		: null,
					initial_date		: null,
					end_date			: null,
					rate				: null,
					fluid_type_id		: null,
					other_terms			: [],
					treatfees			: [
						{
							treatment_fee_type_id: null,
							treatment_fee: null,
							condition_id: null,
							percentage: null,
						}
					],
					otherfees: [
						{
							terminal_rate: null,
							rate: null
						}
					],
					unload_locations	: [],
					load_locations_id	: [],
				},
				treatmentfee: '',
				percentage: '',
				monthly_commitment: '',
				newUnloadLocation: false,
				newLoadLocation: false,
				u_location_id: '',
				loadlocationselect: [],
				indeterminateLL: false,
				llAllSelected: false,
				load_locations: [],
				newModal: false,
				modalTabIndex: 0,
				terminals : []
				// end add
			}
		},
		computed: {
		  sortOptions () {
			// Create an options list from our fields
			return this.fieldsTh
			  .filter(f => f.sortable)
			  .map(f => { return { text: f.label, value: f.key } })
		  }
		},
		methods: {
				// add by Carlos rondon 21/03/2019
				addloadlocation() {
					let ll=[]
					if (this.model.load_locations_id.length != 0) 
					{
						ll = this.model.load_locations_id.map(item => {
							let ll_index = this.loadlocationselect.map(o => o.id).indexOf(item)
							if (ll_index > -1) {
							return this.loadlocationselect[ll_index]
						}
					})
					}
					this.load_locations=ll
					this.newLoadLocation=false
				},
				hideloadlocation() {
					this.newLoadLocation=false
				},
				loadLocationsChange() {
					if (this.role =='super_admin') {
						if (this.model.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
						} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
						} else {
						this.indeterminateLL = true
						this.llAllSelected = false
						}
					}
				},
				LLToggleAll(checked) {
					this.model.load_locations_id = checked ? this.loadlocationselect.map(item => {
						return item.id
					}) : []
			  	},
				showloadlocation() {
						this.newLoadLocation=true
				},
				showunloadlocation() {
						this.newUnloadLocation=true
				},
				addunloadlocation_2() {
						let unload_location	= {
							id: null,
							name: null,
							shipping_cost: null,
							monthly_commitment: null,
							contact_person: null,
							contact_email: null,
							terminal_costs: []
						}
						this.model.unload_locations.push(unload_location)
				},
				addtreatmentfee() {
						this.model.treatfees.push(this.treatfees)
						this.treatfees= {
						treatment_fee_type_id	:null,
						treatment_fee					: null,
						condition_id					: null,
						percentage						: null,
					}
				},
				otherfee() {
						this.model.otherfees.push(this.otherfees)
						this.otherfees= {
						terminal_rate				: null,
						rate								: null
				}
				},
				addterminalcost(row) {
					let index = row.index
					let terminal_cost= {
						terminal_cost_name: null,
						percentage	: null
					}
					this.model.unload_locations[index].terminal_costs.push(terminal_cost)
					this.terminal_cost= {
						terminal_cost_name: null,
						percentage	: null
					}
					if (!row.detailsShowing)
					{
						row.toggleDetails()
					}
				},
				removetreatmentfee(treatfee) {
					this.model.treatfees.splice(treatfee,1)
				},
				removeotherfee(otherfee) {
				  this.model.otherfees.splice(otherfee,1)
				},
				removelocation(location) {
					let unload_l= {
						value: this.model.unload_locations[location].id,
						text: this.model.unload_locations[location].name
					}
					this.locations.push(unload_l)
					this.locations.sort(function (a, b) {
  					if (a.text > b.text) {
						return 1;
  					}
  					if (a.text < b.text) {
					return -1;
  					}
  					// a must be equal to b
  					return 0;
					})
					this.model.unload_locations.splice(location,1)
				},
				removeterminalcost(row, terminalcost) {
					this.model.unload_locations[row.index].terminal_costs.splice(terminalcost,1)
					
					if(this.model.unload_locations[row.index].terminal_costs.length == 0){
						row.toggleDetails()
					}
				},
				// end
				myOnlyNumber(evt, variableName) {
					let dotPosition = this[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
				},
				isNumber: function(evt, hasDot, dotPosition, length) {
					evt = (evt) ? evt : window.event;
					var charCode = (evt.which) ? evt.which : evt.keyCode;
					if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					// if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
						let selectionStart = evt.target.selectionStart;
						let selectionEnd = evt.target.selectionEnd;
						if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
							evt.preventDefault();
						} else {
							return true
						}
					} else {
						evt.preventDefault();
					}
				},
			onFiltered (filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
					this.currentPage = parseInt(localStorage.taPage)
				this.totalRows = filteredItems.length
				this.currentPage = 1
			},
			resetModal () {
				this.modalInfo.title = ''
				this.modalInfo.content = ''
				},
				hideNewServiceModal() {
					this.list=true
					// this.$refs.newLocationModal.hide()
				},
				showNewLocationModal() {
					this.savebtn=false
					this.model={
						id 					: null,
						energy_company_id 	: null,
						terminal_company_id : null,
						terminal_id 		: null,
						initial_date 		: null,
						end_date 			: null,
						rate				: null,
						fluid_type_id		: null,
						other_terms			: [],
						treatfees			: [{
								treatment_fee_type_id	:null,
								treatment_fee			: null,
								condition_id			: null,
								percentage				: null,
						}],
						otherfees						: [{
								terminal_rate			: null,
								rate					: null
						}],
						unload_locations  		: [],
						load_locations_id		: [],
					}
					this.fluid_type  						= {id:null,name:null}
					this.newLocations = true
					this.modalTabIndex = 0
					this.newModal = true
				},
				trashAgreement() {
					this.trash = !this.trash
					this.dpdt = this.trash ? "Trash" : "Active"
					this.getAll()
					this.loadingData = true
				},
				rowClicked(row) {
					localStorage.taPage = this.currentPage;
					if(!this.trash) {
						this.$router.push('/terminal_agreement/'+row.id)
					} else {
						this.restoreTerminalAgreement(row.id)
					}
				},
				restoreTerminalAgreement(id) {
					this.$swal({
						title: 'Please, confirm',
						text: "Are you sure to restore this Terminal Agreement?",
						type: 'question',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes',
						reverseButtons: true
					}).then((result) => {
						if (result.value) {
							t_agreement.restore(id)
								.then(data => {
									this.$swal(data[0], data[1], data[0])
									if (data[0] == 'success') {
										this.filter = ''
										this.trash = false
										this.dpdt='Active'
										this.getAll()
										this.loadingData = true
									}
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
						}
					})
				},
				okToSave() {
					if (this.role =='super_admin') {
						if( this.model.energy_company_id == null) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							this.modalTabIndex = 0
							return false
						}
					}
					if(this.model.fluid_type_id == null) {
						this.$swal('Alert!', 'Fluid Type not selected', 'warning')
						this.modalTabIndex = 0
						return false
					} else if(this.model.initial_date == null || this.model.initial_date == '') {
						this.$swal('Alert!', 'Initial Date not selected', 'warning')
						this.modalTabIndex = 0
						return false
					} else if(this.model.end_date == null || this.model.end_date == '') {
						this.$swal('Alert!', 'End Date not selected', 'warning')
						this.modalTabIndex = 0
						return false
					} else if( this.model.rate == null || this.model.rate == '') {
						this.$swal('Alert!', 'Rate cannot be empty', 'warning')
						this.modalTabIndex = 0
						return false
					} else if( this.model.terminal_company_id == null) {
						this.$swal('Alert!', 'Terminal Company not selected', 'warning')
						this.modalTabIndex = 0
						return false
					} else if( this.model.terminal_id == null) {
						this.$swal('Alert!', 'Terminal not selected', 'warning')
						this.modalTabIndex = 0
						return false
					} else if(this.model.other_terms.length > 0) {
						if(this.model.other_terms[0].stream_type_id==null){
							this.$swal('Alert!', 'Stream Type not selected', 'warning')
							this.modalTabIndex = 0
							return false
						} else if(this.model.other_terms[0].blending_dry_fee==null || this.model.other_terms[0].blending_dry_fee == '') {
							this.$swal('Alert!', 'Blending Dry Fee cannot be empty', 'warning')
							this.modalTabIndex = 0
							return false
						}
					} else if(this.model.treatfees.length>0){
							let length = this.model.treatfees.length;
							for (var i = 0; i < length; i++) {
								if(this.model.treatfees[i].treatment_fee_type_id	==null) {
									this.$swal('Alert!', 'Treatment fee type not selected', 'warning')
									this.modalTabIndex = 1
									return false
								} else if(this.model.treatfees[i].treatment_fee	== null || this.model.treatfees[i].treatment_fee == '') {
									this.modalTabIndex = 1
									this.$swal('Alert!', 'Treatment fee cannot be empty', 'warning')
									return false
								} else if(this.model.treatfees[i].condition_id	== null) {
									this.modalTabIndex = 1
									this.$swal('Alert!', 'Condition of treatment fee not selected', 'warning')
									return false
								} else if(this.model.treatfees[i].percentage == null || this.model.treatfees[i].percentage == '') {
									this.modalTabIndex = 1
									this.$swal('Alert!', 'Percentage of treatment fee cannot be empty', 'warning')
									return false
								}
							} 
					} 
					
					if(this.model.otherfees.length>0){
							let length = this.model.otherfees.length;
							for (var i = 0; i < length; i++) {
								if(this.model.otherfees[i].terminal_rate == null || this.model.otherfees[i].terminal_rate == '') {
									this.$swal('Alert!', 'Other fee terminal rate cannot be empty', 'warning')
									this.modalTabIndex = 2
									return false
								} else if(this.model.otherfees[i].rate	== null || this.model.otherfees[i].rate	== '') {
									this.$swal('Alert!', 'Other fee rate cannot be empty', 'warning')
									this.modalTabIndex = 2
									return false
								}  
							}			
					} 
					
					if(this.model.unload_locations.length>0){
							let length = this.model.unload_locations.length;
							for (var i = 0; i < length; i++) {
								if(this.model.unload_locations[i].id == null) {
									this.$swal('Alert!', 'Unload location not selected', 'warning')
									this.modalTabIndex = 3
									return false
								}	
								else if(this.model.unload_locations[i].shipping_cost	== null || this.model.unload_locations[i].shipping_cost=='') {
									this.$swal('Alert!', 'Shipping cost	 cannot be empty', 'warning')
									this.modalTabIndex = 3
									return false
								} else if(this.model.unload_locations[i].monthly_commitment	== null || this.model.unload_locations[i].monthly_commitment == '') {
									this.$swal('Alert!', 'Monthly commitment cannot be empty', 'warning')
									this.modalTabIndex = 3
									return false
								} else if(this.model.unload_locations[i].contact_person	== null || this.model.unload_locations[i].contact_person == '') {
									this.$swal('Alert!', 'Contact person cannot be empty', 'warning')
									this.modalTabIndex = 3
									return false
								} else if(this.model.unload_locations[i].contact_email	== null || this.model.unload_locations[i].contact_email == '') {
									this.$swal('Alert!', 'Contact email cannot be empty', 'warning')
									this.modalTabIndex = 3
									return false
								}
								if(this.model.unload_locations[i].terminal_costs.length>0){
									let length1 = this.model.unload_locations[i].terminal_costs.length;
									for (var j = 0; j < length1; j++) {
										if(this.model.unload_locations[i].terminal_costs[j].terminal_cost_name==null || this.model.unload_locations[i].terminal_costs[j].terminal_cost_name=='' ) {
											this.$swal('Alert!', 'Terminal cost	 cannot be empty', 'warning')
											this.modalTabIndex = 3
											return false
										} else if(this.model.unload_locations[i].terminal_costs[j].percentage	== null || this.model.unload_locations[i].terminal_costs[j].percentage	== '') {
											this.$swal('Alert!', 'Percentage of terminal cost cannot be empty', 'warning')
											this.modalTabIndex = 3
											return false
										}
									}			
							  }
							}
					} else {
						this.$swal('Alert!', 'No Unload Locations have been added', 'warning')
						this.modalTabIndex = 3
						return false
					}
					if(this.model.load_locations_id.length==0){
						this.$swal('Alert!', 'Load Location not selected', 'warning')
						this.modalTabIndex = 4
						return false
					}
					return true			
				},
	  		saveTerminalAgreement () {
				if(!this.okToSave()) {
		  			return
				}
				this.savebtn=true
				if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
					this.model.energy_company_id = this.energy_company_id
				}
				t_agreement.save(this.model)
				.then(data => {
			  		this.$swal(data[0], data[1], data[0])
					if (data[0] == 'success') {
						this.newLocations = false
										this.getAll()
										this.list=true
										this.newModal = false
					}
					this.savebtn=false
				})
				.catch(error => {
				  this.$swal('Error', 'Server not response. ' + error, 'error')
				  this.savebtn=false
							})
				
	  		},
	  getAll () {
		this.loadingData = true
		t_agreement.getAll()
		  .then(data => {
				if (data.status == 'success') {
					this.items = data.t_agreements.filter(o => o.status_id == (this.trash ? 2 : 1))
					this.role = data.role
					if (this.role =='super_admin') {
						this.view=true
					} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
							this.view=false
							this.energy_company_id = data.energy_company_id
						//	if (this.energycompanies.length!=0) {
						//		let loadlocations = this.energycompanies[0].load_locations
						//		this.loadlocationselect = [...loadlocations]
						//	} else {
						//		this.loadlocationselect = []
						//	}
						this.model.load_locations_id = []
						this.model.energy_company_id = this.energy_company_id
					}
					this.get_attributtes()
				} else {
				  this.items = []
				  this.$swal(data.status, data.message, data.status)
				}
				this.loadingData = false
		  })
		  .catch(error => {
			this.$swal('Error', 'Server not response. ' + error, 'error')
			this.loadingData = false
		  })
			},
			 select_energy_companies1() {
				if (this.model.location_id != null) {
				t_agreement.getEnergyCompaniesUnload(this.model.location_id)
					.then(data => {
						if (data[0] == 'success') {
			  this.energycompanies=data[1].map(item => {
											return { text: item.name, value: item.id }
						})
						} else { this.$swal(data[0], data[1], data[0])
											this.energycompanies=[] }
						})
						.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
						})
						this.model.energy_company_id = null
					}
				},
				select_energy_company() {
					if (this.role =='super_admin') {
						let energy_companies = this.insert_data.energy_companies
						let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
						if (energy_company_index > -1) {
							let loadlocations = energy_companies[energy_company_index].load_locations
							this.loadlocationselect = [...loadlocations]
					} else {
						this.loadlocationselect = []
					}
					this.model.load_locations_id = []
					}
				},
				select_terminal() {
					if (this.role =='super_admin') {
						let terminals = this.insert_data.terminals
						let terminal_index = terminals.map(o => o.id).indexOf(this.model.terminal_id)
						if (terminal_index > -1) {
							if (terminals[terminal_index].unload_location.length>0) {
								this.model.unload_locations = []
								let unload_locations  		= {
									id					: terminals[terminal_index].unload_location[0].id,
									name				: terminals[terminal_index].unload_location[0].name,
									shipping_cost		: null,
									monthly_commitment	: null,
									contact_person		: null,
									contact_email		: null,
									terminal_costs		: [],
								}
								this.model.unload_locations.push(unload_locations)							
							} else {
								this.model.unload_locations = []
							}
							
						} else {
							this.model.unload_locations = []
						}
					}		
				},
				select_fluid_type() {
						this.model.fluid_type_id = this.fluid_type.id
						if (this.fluid_type.name=='Oil') {
								this.model.other_terms.push(this.other_term)
						} else {
							  this.model.other_terms = []
						}
				},
			get_attributtes() {
				t_agreement.get_attr_ta()
					.then(data => {
						if (data.status == 'success') {
							if(data.insert_data) {
								this.insert_data = data.insert_data
								if (data.insert_data.locations_unload.length!=0) {
											this.locations  = data.insert_data.locations_unload.map(item => {
											return { text: item.name, value: item.id }
								})
								}
								// added by Carlos Rondon 21/03/2019
								if (data.insert_data.fluidtypes.length!=0) {
									this.fluidtypes  = data.insert_data.fluidtypes
								}
								
								this.terminals  		= data.insert_data.terminals
								this.energycompanies  	= data.insert_data.energy_companies						
								this.terminalcompanies  = data.insert_data.terminal_companies
								if (data.insert_data.treatment_fee_type.length!=0) {
									this.treatment_fee_type	= data.insert_data.treatment_fee_type.map(item => {
										return { text: item.name, value: item.id }

								})
								}

								if (data.insert_data.conditions.length!=0) {
								this.condition = data.insert_data.conditions.map(item => {
									return { text: item.name, value: item.id }

								})
								}
								if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
									if (this.energycompanies.length!=0) {
										let loadlocations = this.energycompanies[0].load_locations
										this.loadlocationselect = [...loadlocations]
									} else {
										this.loadlocationselect = []
									}
								}
									// end added
							}
						} else {
							this.$swal(data.status, data.message, data.status)
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
			},
	  }
	}
</script>
<style scoped>
	/deep/ .nav-link.active {
		font-weight: bold;
	} 
	/deep/ .col-form-label{
		font-weight: bold;
	}
	/deep/ .modal-lg {
    	max-width: 1000px;
	}
	/deep/	.custom-checkboxes .form-check-inline {
		width: 35vh;
	}
	/deep/	.custom-checkboxes .form-check-label {
    	overflow: unset;
	}
	.card-body >>> .b-table.table.b-table-stacked > tbody > tr > [data-label] {
		display: grid;
		grid-template-columns: 15% 85%;
		grid-gap: 0.25rem 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/views/terminal_agreements/terminal_agreements.vue